import React, { useRef, useEffect } from "react";
import {
  Box,
} from "@chakra-ui/react";
import useOutlineStore from "../../stores/modules/outline.ts";
import { BlockEditorApp } from "../Editor/BlockEditorApp.tsx";
import { convertOutlineToTiptapJson } from "../../utils/tiptapConverter.ts";
import { dedupeIds } from "../../utils/const.ts";

/**
 * main editor area
 */
interface SectionContentProps {
  updateOutline: () => void
  editor: any
  setEditor: any
  editorRef: any
  zoomLevel: string
}

export const SectionContent: React.FC<SectionContentProps> = ({ editor, editorRef, setEditor, zoomLevel }) => {
  const sectionRef = useRef<HTMLDivElement | null>(null);
  const { outline, currentSectionIndex, setOutlineIsChange, setOutline, setNextId } = useOutlineStore()
  const [tiptapJson, setTiptapJson] = React.useState<any>({
    type: "doc",
    content: []
  })

  useEffect(() => {
    if (outline?.nodes?.length) {
      const json = convertOutlineToTiptapJson(outline.nodes[currentSectionIndex])
      setTiptapJson(json)
    }
  }, [currentSectionIndex, outline]);

  return (
    <Box ref={sectionRef} overflowY={'auto'} height={`100%`}>
      <BlockEditorApp editor={editor} setEditor={setEditor} editRef={editorRef} tiptapJson={tiptapJson} zoomLevel={zoomLevel} handleSave={(section: any) => {
        let outlineTemp: any = sessionStorage.getItem('do_outline')
        if (outlineTemp) {
          outlineTemp = JSON.parse(outlineTemp)
          outlineTemp.nodes[currentSectionIndex] = section
          // 第一层级ID去重并同步更新 nextId
          const { outline: fixedOutline, nextId: updatedNextId } = dedupeIds(outlineTemp)
          setOutline(fixedOutline)
          setNextId(updatedNextId)
          console.log(outlineTemp, 1)
          console.log(fixedOutline, 2)
          setOutlineIsChange(true)
        }
      }} />
    </Box>
  )
}